export function validationNegativeValue(value: number | undefined, t: (key: string) => string): string | undefined {
    if (value !== undefined && value < 0) {
        return t("FilterRangeUsageStorage.valueCannotBeNegative");
    }
    return undefined;
}
